import { render, staticRenderFns } from "./Invite.vue?vue&type=template&id=1cc7ea6b&scoped=true&"
import script from "./Invite.vue?vue&type=script&setup=true&lang=js&"
export * from "./Invite.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc7ea6b",
  null
  
)

export default component.exports